import script from "./StartView.vue?vue&type=script&setup=true&lang=ts"
export * from "./StartView.vue?vue&type=script&setup=true&lang=ts"

import "./StartView.vue?vue&type=style&index=0&id=74b98882&lang=scss"

const __exports__ = script;

export default __exports__